// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DvgE","clinicsSelect":"styles_clinicsSelect__3uhZq"};